var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{on:{"enter":_vm.enter,"after-enter":_vm.afterEnter,"before-leave":_vm.beforeLeave,"leave":_vm.leave}},[_c('div',{ref:"container",staticClass:"collapsible-container",style:(_vm.style)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }